import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IAPIItemResult} from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateMaterial } from "../interfaces/update-material.interface";
import { environment as env } from "../../../../../../environments/environment.prod";
import { ICreateDimension } from "../interfaces/create-material-dimension";
import DimensionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/dimensions/dimension.entity";


const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_dimensions";

@Injectable({
  providedIn: "root",
})
export class MaterialDimensionService extends AbstractService<
DimensionAttributes,
ICreateDimension,
IUpdateMaterial
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialId(materialId: string,id:string): Observable<IAPIItemResult<DimensionAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialId}/${id}`;
    return this.http.get<IAPIItemResult<DimensionAttributes>>(API_URL);
  }
}